import { useAuthStore } from '@/stores/auth'
export enum Host {
  API,
  AUTH,
  TRANSACTION
}

const BASE_URL = {
  [Host.API]: import.meta.env.VITE_HOST_API,
  [Host.AUTH]: import.meta.env.VITE_HOST_AUTH,
  [Host.TRANSACTION]: import.meta.env.VITE_HOST_TRANSACTION
}

const fetchData = async (endpoint: string, options: RequestInit = {}, host: Host) => {
  try {
    const response = await fetch(`${BASE_URL[host]}${endpoint}`, {
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...(await Authorization())
      }
    })

    if (response.status === 403) {
      handleUnauthorized()
      return Promise.reject({ message: 'Unauthorized', status: 403 })
    }

    return await response.json()
  } catch (error) {
    console.error('Error en fetchData:', error)
    return Promise.reject(error)
  }
}

const handleUnauthorized = () => {
  localStorage.removeItem('wepago-token')
  const { onSignOut } = useAuthStore()
  onSignOut() // Llamar la función logout del store si existe
}

export const getData = (endpoint: string, host: Host = Host.API) =>
  fetchData(endpoint, { method: 'GET' }, host)
export const postData = (endpoint: string, data: any, host: Host = Host.API) =>
  fetchData(endpoint, { method: 'POST', body: JSON.stringify(data) }, host)
export const putData = (endpoint: string, data: any, host: Host = Host.API) =>
  fetchData(endpoint, { method: 'PUT', body: JSON.stringify(data) }, host)
export const deleteData = (endpoint: string, host: Host = Host.API) =>
  fetchData(endpoint, { method: 'DELETE' }, host)

export const Authorization = async () => {
  try {
    const localToken = localStorage.getItem('wepago-token')
    if (localToken) {
      return { Authorization: `Bearer ${localToken}` } as HeadersInit
    }

    const { checkAuth, getAuthToken } = useAuthStore()
    const isLogged = await checkAuth()

    if (!isLogged) {
      return {} as HeadersInit
    }

    const token = await getAuthToken()
    return { Authorization: `Bearer ${token}` } as HeadersInit
  } catch (error) {
    console.error(error)
    return {}
  }
}
